// plugins/toast.ts
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(async (nuxtApp) => {
  if (import.meta.client) {
    const OxiaClient = await import('@oxia/client');
    const { useToast } = OxiaClient;

    // Inject useToast function into the global app context
    nuxtApp.provide('useToast', useToast);
  }
});
